import React from 'react';
import {Typography} from '@mui/material';
import Box from '@mui/material/Box';
import './DeviceInfoPopup.css';
import {ValueSlider} from '../../utils';


export default function DeviceInfoPopup({name, pm10, pm25, noise, date, top, left}) {
  const list = [
    {label: 'PM10', 'value': pm10, units: 'µg/m³'},
    {label: 'PM2.5', 'value': pm25, units: 'µg/m³'},
    {label: 'Hałas', 'value': noise, units: 'dBA'},
  ];

  return <Box
    position={'absolute'}
    className={'custom-popup-wrapper'}
    minWidth={300}
    px={2}
    py={2.5}
    top={top}
    left={left}
  >
    <Typography variant={'h6'}>{name}</Typography>
    <Box textAlign={'left'}>
      <Typography variant={'caption'}> Ostatni odczyt: {date.toLocaleString()}</Typography>
    </Box>

    <Box mt={4} display={'flex'} flexDirection={'column'} alignItems={'flex-start'} gap={2.5}>
      {list
        .filter(({value}) => value != null || value !== undefined)
        .map(({label, value, units}) => <Box width={'100%'}>
          <Box textAlign={'left'}>
            <Typography display={'inline'} fontWeight={'bold'} variant={'body2'}>
              {label}:{' '}
            </Typography>
            <Typography display={'inline'} variant={'body2'}>
              {(value || 0).toFixed(2)} {units}
            </Typography>
          </Box>
          <ValueSlider
            measurementType={'PM10'}
            value={value || 0}
          />
        </Box>)
      }

    </Box>
  </Box>;
};
